// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyModel {
    static getAttributeTypeMap() {
        return PharmacyModel.attributeTypeMap;
    }
}
PharmacyModel.discriminator = undefined;
PharmacyModel.attributeTypeMap = [
    {
        "name": "pharmacyId",
        "baseName": "pharmacyId",
        "type": "number"
    },
    {
        "name": "pharmacyName",
        "baseName": "pharmacyName",
        "type": "string"
    },
    {
        "name": "nabp",
        "baseName": "nabp",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "pharmacyType",
        "baseName": "pharmacyType",
        "type": "PharmacyType"
    },
    {
        "name": "pharmacySpecialization",
        "baseName": "pharmacySpecialization",
        "type": "PharmacySpecialization"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<PharmacySharedAddressModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<PharmacySharedPhoneModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<PharmacySharedEmailAddressModel>"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": "Array<PharmacySharedWebAddressModel>"
    }
];
//# sourceMappingURL=pharmacyModel.js.map